import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { WeekSlotInput } from "../gql/graphql.ts";

const UpdateBulkClassRoomCreationIntentMutation = gql`
  mutation updateBulkClassRoomCreationIntent(
    $input: UpdateBulkClassRoomCreationIntentInput!
  ) {
    updateBulkClassRoomCreationIntent(input: $input) {
      id
      createdAt
      startDate
      numberOfWeeks
      maxClassRoomNumber
      user1on1ClassroomPlanToBeRedeemedId
      excludedSlots
      additionalSlots {
        startDateUtc
        endDateUtc
      }
      teacher {
        id
        givenName
        familyName
      }
      user {
        id
        givenName
        familyName
      }
      weekSlots {
        dayOfWeek
        startTime
        endTime
      }
    }
  }
`;

export function useUpdateBulkClassRoomCreationIntent() {
  const [updateMutation, { loading }] = useMutation(
    UpdateBulkClassRoomCreationIntentMutation,
  );

  const updateBulkClassRoomCreationIntent = useCallback(
    async (input: {
      id: string;
      teacherId?: string;
      startDate?: string;
      numberOfWeeks?: number;
      maxClassRoomNumber?: number;
      weekSlots?: WeekSlotInput[];
      excludedSlots?: string[];
      additionalSlots?: { startDateUtc: string; endDateUtc: string }[];
    }) => {
      const res = await updateMutation({ variables: { input } });
      const intent = res.data?.updateBulkClassRoomCreationIntent;
      if (!intent)
        throw new Error("Unable to update bulk classroom creation intent");
      return intent;
    },
    [updateMutation],
  );

  return {
    loading,
    updateBulkClassRoomCreationIntent,
  };
}
